import axios from "axios";

export const register = (registry, captchaToken) => {
  return axios.post("/api/member-registration/register", registry, {
    headers: {
      Captcha: captchaToken
    }
  });
};

export const activate = (registry, captchaToken) => {
  return axios.post("/api/member-registration/activate", registry, {
    headers: {
      Captcha: captchaToken
    }
  });
};

export const registerOwnerAssistant = (registry, businessId) => {
  return axios.post(`/api/member-registration/helper-owner/register`, registry,{
    params: {
      businessID: businessId
    }
  })
}

export const loginProfessional = (data) => {
  return axios.post(`/api/member-registration/prof/loginExisting`, data)
}

export const loginPublicUser = (data) => {
  return axios.post(`/api/member-registration/public-user/loginExisting`, data)
}

export const loginAssistant = (data) => {
  return axios.post(`/api/member-registration/helper/loginExisting`, data)
}

export const loginOwner = (data) => {
  return axios.post(`/api/member-registration/owner/loginExisting`, data)
}


export const resetCertification = (data) => {
  return axios.post(`/api/member-registration/resetCertification`, data)
}



export const registerPublicUser = (registry, businessId) =>
  axios.post(`/api/member-registration/public-user/register`, registry, {
    params: {
      businessID: businessId
    }
  });



export const registerProfessional = (registry, businessId) =>
  axios.post(`/api/member-registration/professional/register`, registry, {
    params: {
      businessID: businessId
    }
  });

export const upgradeProfessional = (registry, businessId) =>
  axios.post(`/api/member-registration/professional/upgrade`, registry, {
    params: {
      businessID: businessId
    }
  });

  export const updateExistingProfessional = (memberId, guid) =>
  axios.post(`/api/member-registration/professional/update-existing`,{
    MemberID:memberId,
    MemberCertificationGUID:guid
  
  });

export const searchMembers = (title, keyword) =>
  axios.get("/api/member-registration/list", {
    params: {
      title,
      keyword
    }
  });

export const searchRprc = (word) =>
  axios.get(`/api/member-registration/rprc?keyword=${word}`);

export const activateProfessional = (businessId) =>
  axios.post("/api/member-registration/professional/activate", null, {
    params: {
      businessID: businessId
    }
  });

export const activateIAMSmart = (businessId) =>
  axios.post(`/api/member-registration/activate/iamsmart`, null, {
    params: {
      businessID: businessId
    }
  });


  